// import external dependencies

import "jquery";
import "parsleyjs";

// Import everything from autoload
import "./autoload/jquery.minimalect.js"; import "./autoload/scrollbar.min.js"; import "./autoload/slick.js";
import "./modules/banner-popup.js"; import "./modules/blog.js"; import "./modules/estimate-form.js"; import "./modules/faq.js"; import "./modules/header.js"; import "./modules/hero-block.js"; import "./modules/join-us-form.js"; import "./modules/ninja-forms-events.js"; import "./modules/page-bundle-and-save.js"; import "./modules/page-hero-block.js"; import "./modules/protect-against.js"; import "./modules/rest-api-helpers.js"; import "./modules/reviews.js"; import "./modules/scroll-to-section.js"; import "./modules/service-areas.js"; import "./modules/video-block.js"; import "./modules/video-popups.js";

jQuery(document).ready(() => {});



// WEBPACK FOOTER //
// ./scripts/main.js